import AuthGate from "./AuthGate";
import { useState, useEffect, useRef } from "react";

const API = window.location.hostname === "localhost" ? "http://localhost:8000" : "https://propflow-backend-production-fa0e.up.railway.app";

const STEPS = [
  { id: "input", label: "Input" },
  { id: "research", label: "Research" },
  { id: "decision", label: "Review" },
  { id: "strategy", label: "Campaign" },
  { id: "assets", label: "Assets" },
  { id: "distribution", label: "Distribute" },
  { id: "delivery", label: "Leads" },
];

function fmtF(n) { if (!n) return "-"; return "$"+n.toLocaleString(); }

function Bar({ p, c }) {
  return <div style={{w:"100%",height:3,background:"rgba(255,255,255,0.08)",borderRadius:2,overflow:"hidden",width:"100%"}}>
    <div style={{width:p+"%",height:"100%",background:c||"#C9A96E",borderRadius:2,transition:"width 0.4s"}}/>
  </div>
  ;
}

function Steps({ idx, onNav }) {
  return <div style={{display:"flex",gap:4,alignItems:"center",padding:"14px 0",flexWrap:"wrap"}}>
    {STEPS.map((s,i) => <div key={s.id} style={{display:"flex",alignItems:"center",gap:4}}>
      <div onClick={function(){if(i<idx && onNav)onNav(s.id);}} style={{
        width:8,height:8,borderRadius:"50%",
        background:i<idx?"#C9A96E":i===idx?"#fff":"rgba(255,255,255,0.15)",
        boxShadow:i===idx?"0 0 8px rgba(201,169,110,0.5)":"none",
        transition:"all 0.3s",
        cursor:i<idx?"pointer":"default"
      }} title={i<idx?s.label:""}/>
      {i<STEPS.length-1&&<div style={{width:10,height:1,background:i<idx?"rgba(201,169,110,0.4)":"rgba(255,255,255,0.08)"}}/>}
    </div>)}
    {idx>0&&<div style={{marginLeft:8,display:"flex",gap:4}}>
      {STEPS.filter((s,i)=>i<idx).map((s,i)=><button key={s.id} onClick={function(){if(onNav)onNav(s.id);}} style={{
        padding:"2px 8px",borderRadius:10,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",
        color:"rgba(255,255,255,0.35)",fontSize:9,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"
      }}>{s.label}</button>)}
    </div>}
  </div>;
}

function Badge({ n, label, on }) {
  return <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:18,opacity:on?1:0.4}}>
    <div style={{width:30,height:30,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",background:on?"rgba(201,169,110,0.15)":"rgba(255,255,255,0.05)",border:"1px solid "+(on?"rgba(201,169,110,0.4)":"rgba(255,255,255,0.08)"),fontSize:12,fontWeight:600,color:on?"#C9A96E":"rgba(255,255,255,0.3)"}}>{n}</div>
    <span style={{fontSize:11,textTransform:"uppercase",letterSpacing:1.5,color:on?"#C9A96E":"rgba(255,255,255,0.3)",fontWeight:500}}>{label}</span>
    {on&&<div style={{width:6,height:6,borderRadius:"50%",background:"#4ADE80",animation:"pulse 1.5s ease infinite"}}/>}
  </div>;
}

function Btn({ children, primary, onClick, disabled }) {
  return <button onClick={onClick} disabled={disabled} style={{
    padding:"12px 28px",background:primary?"#C9A96E":"transparent",
    border:primary?"none":"1px solid rgba(255,255,255,0.1)",borderRadius:8,
    color:primary?"#080C10":"rgba(255,255,255,0.5)",fontSize:14,fontWeight:600,
    cursor:disabled?"default":"pointer",fontFamily:"'DM Sans',sans-serif",
    opacity:disabled?0.4:1,transition:"all 0.2s"
  }}>{children}</button>;
}

function Card({ children, style }) {
  return <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.06)",borderRadius:12,padding:20,...style}}>{children}</div>;
}

function Lbl({ children }) {
  return <div style={{fontSize:11,textTransform:"uppercase",letterSpacing:1.2,color:"rgba(255,255,255,0.35)",marginBottom:4,fontWeight:500}}>{children}</div>;
}

function Val({ children }) {
  return <div style={{fontSize:15,color:"#E8DCC8",fontWeight:400}}>{children}</div>;
}

function Swatch({ hex, name }) {
  return <div style={{textAlign:"center"}}>
    <div style={{width:40,height:40,borderRadius:8,background:hex,border:"1px solid rgba(255,255,255,0.1)"}}/>
    <div style={{fontSize:9,color:"rgba(255,255,255,0.3)",marginTop:3}}>{name}</div>
  </div>;
}

export default function AdPilot() {
  var [step, setStep] = useState("input");
  var [name, setName] = useState("");
  var [fade, setFade] = useState(true);
  var [logs, setLogs] = useState([]);
  var [rDone, setRDone] = useState(false);
  var [rErr, setRErr] = useState(null);
  var [proj, setProj] = useState(null);
  var [rr, setRR] = useState(null);
  var [camp, setCamp] = useState(null);
  var [campLoad, setCampLoad] = useState(false);
  var [campErr, setCampErr] = useState(null);
  var [dir, setDir] = useState(null);
  var [assets, setAssets] = useState(null);
  var [assetsLoad, setAssetsLoad] = useState(false);
  var [assetsErr, setAssetsErr] = useState(null);
  var [assetProg, setAssetProg] = useState(0);
  var [editing, setEditing] = useState(false);
  var [edits, setEdits] = useState({});
  var [editingData, setEditingData] = useState(false);
  var [editingUnits, setEditingUnits] = useState(false);
  var [editingDeposit, setEditingDeposit] = useState(false);
  var [imageUrls, setImageUrls] = useState([]);
  var [uploading, setUploading] = useState(false);
  var [showUpload, setShowUpload] = useState(false);
  var [selectedIncentives, setSelectedIncentives] = useState([]);
  var [disabledScrapedIncentives, setDisabledScrapedIncentives] = useState([]);
  var [customIncentive, setCustomIncentive] = useState("");
  var [cappedDCInput, setCappedDCInput] = useState(false);
  var [cappedDCAmount, setCappedDCAmount] = useState("");
  var [deployment, setDeployment] = useState(null);
  var [deployLoading, setDeployLoading] = useState(false);
  var [leads, setLeads] = useState([]);
  var [leadStats, setLeadStats] = useState(null);
  var [recents, setRecents] = useState([]);
  var [ratings, setRatings] = useState({});
  var [ratingIssues, setRatingIssues] = useState(null);
  var [showSettings, setShowSettings] = useState(false);
  var [exportLoading, setExportLoading] = useState(false);
  var [testEmailSent, setTestEmailSent] = useState(false);
  var [metaConnected, setMetaConnected] = useState(false);
  var [metaUser, setMetaUser] = useState(null);
  var [metaAdAccounts, setMetaAdAccounts] = useState(0);
  var [launchBudget, setLaunchBudget] = useState(20);
  var [launchCity, setLaunchCity] = useState("");
  var [launchAgeMin, setLaunchAgeMin] = useState(25);
  var [launchAgeMax, setLaunchAgeMax] = useState(55);
  var [launching, setLaunching] = useState(false);
  var [launchResult, setLaunchResult] = useState(null);
  var [agentProfile, setAgentProfile] = useState({agent_name:"",agent_title:"Sales Representative",brokerage_name:"",brokerage_descriptor:"Brokerage",phone:"",email:"",website:""});
  var fileRef = useRef(null);
  var esRef = useRef(null);
  var si = STEPS.findIndex(function(s){return s.id===step;});

  function cacheKey(pname,type){return "pf_"+pname.toLowerCase().replace(/\s/g,"-")+"_"+type;}
  function saveToCache(pname,type,data){try{localStorage.setItem(cacheKey(pname,type),JSON.stringify(data));}catch(e){}}
  function loadFromCache(pname,type){try{var d=localStorage.getItem(cacheKey(pname,type));return d?JSON.parse(d):null;}catch(e){return null;}}
  function saveRecent(pname,score,extra){
    try{
      var list=JSON.parse(localStorage.getItem("pf_recents")||"[]");
      var existing=list.find(function(r){return r.name===pname;})||{};
      list=list.filter(function(r){return r.name!==pname;});
      list.unshift({...existing,name:pname,score:score,time:Date.now(),...(extra||{})});
      if(list.length>10)list=list.slice(0,10);
      localStorage.setItem("pf_recents",JSON.stringify(list));
      setRecents(list);
    }catch(e){}
  }
  function updateRecent(pname,updates){
    try{
      var list=JSON.parse(localStorage.getItem("pf_recents")||"[]");
      list=list.map(function(r){return r.name===pname?{...r,...updates,time:Date.now()}:r;});
      localStorage.setItem("pf_recents",JSON.stringify(list));
      setRecents(list);
    }catch(e){}
  }
  function loadRecents(){try{return JSON.parse(localStorage.getItem("pf_recents")||"[]");}catch(e){return [];}}

  useEffect(function(){
    setRecents(loadRecents());
    fetch(API+"/compliance/profile").then(function(r){return r.json();}).then(function(d){if(d.agent_name)setAgentProfile(d);}).catch(function(){});
    fetch(API+"/auth/meta/status?agent_id="+encodeURIComponent("maged.rmze@gmail.com"))
      .then(function(r){return r.json();})
      .then(function(d){if(d.connected){setMetaConnected(true);setMetaUser(d.user_name);setMetaAdAccounts(d.ad_accounts);}})
      .catch(function(){});
    var params=new URLSearchParams(window.location.search);
    if(params.get("meta_connected")==="true"){setMetaConnected(true);window.history.replaceState({},"",window.location.pathname);}
  },[]);

  function saveAgentProfile(p){
    setAgentProfile(p);
    fetch(API+"/compliance/profile",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(p)}).catch(function(e){console.error(e);});
  }

  function go(n){setFade(false);setTimeout(function(){setStep(n);setFade(true);},250);}

  function startResearch(n, skipCache){
    if(!skipCache){
      var cached=loadFromCache(n,"research");
      if(cached){
        setName(n);setRR(cached);setProj(cached.project);setRDone(true);
        setLogs([{text:"Loaded from cache — "+cached.completeness_score+"%",s:"done"}]);
        var cachedCamp=loadFromCache(n,"campaign");
        if(cachedCamp)setCamp(cachedCamp);
        go("decision");
        return;
      }
    }
    setLogs([]);setRDone(false);setRErr(null);setProj(null);setRR(null);
    setCamp(null);setCampErr(null);setAssets(null);setDir(null);
    go("research");
    setTimeout(function(){
      var es=new EventSource(API+"/research/stream?q="+encodeURIComponent(n));
      esRef.current=es;
      var gotResult=false;
      var phase="search";
      var errCount=0;
      es.addEventListener("search_start",function(e){if(phase!=="search")return;var d=JSON.parse(e.data);setLogs(function(p){return p.concat([{text:"Searching for \""+d.project+"\"...",s:"active"}]);});});
      es.addEventListener("search_complete",function(e){if(phase!=="search")return;phase="scrape";var d=JSON.parse(e.data);setLogs(function(p){return p.concat([{text:"Found "+d.total_results+" results",s:"done"}]);});});
      es.addEventListener("scrape_start",function(e){if(phase!=="scrape")return;var d=JSON.parse(e.data);setLogs(function(p){return p.concat([{text:"Scraping "+d.total_urls+" pages...",s:"active"}]);});});
      es.addEventListener("scrape_complete",function(e){if(phase!=="scrape")return;phase="extract";var d=JSON.parse(e.data);setLogs(function(p){return p.concat([{text:"Scraped "+d.scraped+" pages ("+d.failed+" failed)",s:d.scraped>0?"done":"warning"}]);});});
      es.addEventListener("extract_start",function(e){if(phase!=="extract")return;phase="extracting";var d=JSON.parse(e.data);setLogs(function(p){return p.concat([{text:"Sending "+d.pages_to_process+" pages to Claude... (this takes ~30s)",s:"active"}]);});});
      es.addEventListener("extract_complete",function(e){var d=JSON.parse(e.data);setLogs(function(p){return p.concat([{text:"Extraction: "+d.completeness+"% coverage",s:d.completeness>=50?"done":"warning"}]);});});
      es.addEventListener("complete",function(){setLogs(function(p){return p.concat([{text:"Research complete",s:"done"}]);});});
      es.addEventListener("result",function(e){if(gotResult)return;gotResult=true;es.close();var r=JSON.parse(e.data);
        setRR(r);setProj(r.project);setRDone(true);
        saveToCache(n,"research",r);
        saveRecent(n,r.completeness_score);
      });
      es.onerror=function(){
        if(gotResult)return;
        errCount++;
        if(errCount>=5){
          es.close();
          if(phase==="extracting"||phase==="extract"){
            setLogs(function(p){return p.concat([{text:"Waiting for extraction to complete...",s:"active"}]);});
            fetch(API+"/research",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({project_name:n})})
              .then(function(r){if(!r.ok)throw new Error("HTTP "+r.status);return r.json();})
              .then(function(r){if(!gotResult){gotResult=true;setRR(r);setProj(r.project);setRDone(true);
                saveToCache(n,"research",r);saveRecent(n,r.completeness_score);
                setLogs(function(p){return p.concat([{text:"Extraction: "+r.completeness_score+"%",s:"done"},{text:"Research complete",s:"done"}]);});}})
              .catch(function(e){if(!gotResult)setRErr("Research failed: "+e.message);});
          } else {
            setRErr("Connection lost. Is the backend running?");
          }
        }
      };
    },400);
  }

  function startCampaign(){
    if(!proj)return;setCampLoad(true);setCampErr(null);setCamp(null);go("strategy");
    setTimeout(function(){
      fetch(API+"/campaign",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({project:proj})})
        .then(function(r){if(!r.ok)throw new Error("HTTP "+r.status);return r.json();})
        .then(function(d){setCamp(d);setCampLoad(false);saveToCache(name,"campaign",d);
          updateRecent(name,{theme:d.theme_name,hasCampaign:true});})
        .catch(function(e){setCampErr(e.message);setCampLoad(false);});
    },400);
  }

  function startAssets(direction){
    if(!proj||!camp)return;setDir(direction);setAssetsLoad(true);setAssetsErr(null);setAssets(null);setAssetProg(0);go("assets");
    setTimeout(function(){
      var allImages = imageUrls.map(function(u){return API + u;});
      if(proj.render_urls&&proj.render_urls.length>0){
        proj.render_urls.forEach(function(u){
          if(u&&u.startsWith("http")&&allImages.indexOf(u)===-1)allImages.push(u);
        });
      }
      fetch(API+"/market/analyze",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({project_name:proj.name||name,project:proj})})
        .then(function(r){return r.ok?r.json():{};})
        .then(function(marketData){
          var mCtx="";
          if(marketData&&marketData.positioning){
            mCtx="\nMARKET CONTEXT:\nPositioning: "+marketData.positioning+"\n";
            if(marketData.area_avg_precon_psf)mCtx+="Area pre-con average: $"+marketData.area_avg_precon_psf+"/sqft\n";
            if(marketData.area_avg_resale_psf)mCtx+="Area resale average: $"+marketData.area_avg_resale_psf+"/sqft\n";
            if(marketData.market_condition)mCtx+="Market: "+marketData.market_condition+"\n";
            if(marketData.estimated_rental_yield)mCtx+="Est. rental yield: "+marketData.estimated_rental_yield+"%\n";
            if(marketData.talking_points&&marketData.talking_points.length>0){
              mCtx+="\nDATA-BACKED TALKING POINTS:\n";
              marketData.talking_points.forEach(function(tp){mCtx+="• "+tp+"\n";});
            }
            mCtx+="\nUse these specific data points in copy. Replace generic claims with real numbers.\n";
          }
          return fetch(API+"/assets/all",{method:"POST",headers:{"Content-Type":"application/json"},
            body:JSON.stringify({project:proj,campaign:camp,direction:direction,image_urls:allImages,market_context:mCtx})});
        })
        .then(function(r){if(!r.ok)throw new Error("HTTP "+r.status);return r.json();})
        .then(function(d){setAssets(d);setAssetsLoad(false);setAssetProg(100);
          updateRecent(name,{direction:direction,hasAssets:true});})
        .catch(function(e){setAssetsErr(e.message);setAssetsLoad(false);});
      var iv=setInterval(function(){setAssetProg(function(p){if(p>=95){clearInterval(iv);return 95;}return p+2;});},500);
    },400);
  }

  function handleUpload(e){
    var files = e.target.files;
    if(!files||!files.length)return;
    setUploading(true);
    var formData = new FormData();
    for(var i=0;i<files.length;i++){formData.append("files",files[i]);}
    formData.append("project_name",proj?proj.name||"":"");
    fetch(API+"/upload",{method:"POST",body:formData})
      .then(function(r){if(!r.ok)throw new Error("HTTP "+r.status);return r.json();})
      .then(function(d){
        if(d.images&&d.images.length>0){setImageUrls(function(p){return p.concat(d.images);});}
        setUploading(false);
      })
      .catch(function(e){console.error("Upload failed:",e);setUploading(false);});
    e.target.value="";
  }

  function resetAll(){
    if(esRef.current)esRef.current.close();
    setName("");setLogs([]);setRDone(false);setRErr(null);setProj(null);setRR(null);
    setCamp(null);setCampErr(null);setCampLoad(false);setAssets(null);setAssetsLoad(false);
    setAssetsErr(null);setDir(null);setAssetProg(0);setEditing(false);setEdits({});
    setImageUrls([]);setShowUpload(false);setDeployment(null);setDeployLoading(false);
    setLeads([]);setLeadStats(null);setSelectedIncentives([]);setDisabledScrapedIncentives([]);setCappedDCInput(false);setCappedDCAmount("");
    go("input");
  }

  function startDeploy(){
    if(!assets||!proj)return;
    setDeployLoading(true);go("distribution");
    setTimeout(function(){
      fetch(API+"/distribute/deploy",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          project_name:proj.name||name,
          landing_page_html:assets.landing_page_html||"",
          email_html:assets.email_html||"",
          social_copy:assets.social_copy||{},
          backend_url:API,
        })})
        .then(function(r){if(!r.ok)throw new Error("HTTP "+r.status);return r.json();})
        .then(function(d){setDeployment(d);setDeployLoading(false);
          updateRecent(name,{status:"running",deployed:true,channels:d.deployed_channels});
          if(agentProfile.email){
            fetch(API+"/notifications/settings",{method:"POST",headers:{"Content-Type":"application/json"},
              body:JSON.stringify({project_name:proj.name||name,agent_email:agentProfile.email,agent_name:agentProfile.agent_name||"",email_enabled:true})})
              .catch(function(e){console.error("Auto-notify setup:",e);});
          }})
        .catch(function(e){console.error("Deploy failed:",e);setDeployLoading(false);});
    },400);
  }

  function fetchLeads(){
    if(!proj)return;
    var pname=proj.name||name;
    fetch(API+"/leads/"+encodeURIComponent(pname))
      .then(function(r){return r.json();})
      .then(function(d){setLeads(d.leads||[]);updateRecent(name,{leadCount:d.total||0});});
    fetch(API+"/leads/stats/"+encodeURIComponent(pname))
      .then(function(r){return r.json();})
      .then(function(d){setLeadStats(d);
        if(d.total_leads)updateRecent(name,{leadCount:d.total_leads,hotLeads:d.hot});});
  }

  function downloadExportPack(){
    if(!assets||!proj)return;
    setExportLoading(true);
    var pname=proj.name||name;
    var utm=deployment?deployment.utm_links||{}:{};
    var body={
      project_name:pname,direction:dir||"analytical",
      email_html:assets.email_html||null,landing_page_html:assets.landing_page_html||null,
      social_copy:assets.social_copy||null,instagram_post:assets.instagram_post||null,
      instagram_story:assets.instagram_story||null,facebook_ad:assets.facebook_ad||null,
      facebook_ad_vertical:assets.facebook_ad_vertical||null,whatsapp_flyer:assets.whatsapp_flyer||null,linkedin_post:assets.linkedin_post||null,
      google_300x250:assets.google_300x250||null,google_728x90:assets.google_728x90||null,
      google_320x50:assets.google_320x50||null,google_160x600:assets.google_160x600||null,
      google_300x600:assets.google_300x600||null,google_336x280:assets.google_336x280||null,
      google_970x250:assets.google_970x250||null,google_320x100:assets.google_320x100||null,
      utm_links:utm,agent_name:agentProfile.agent_name||null,brokerage_name:agentProfile.brokerage_name||null,
    };
    fetch(API+"/export/pack",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)})
      .then(function(r){if(!r.ok)throw new Error("HTTP "+r.status);return r.blob();})
      .then(function(blob){
        var url=window.URL.createObjectURL(blob);
        var a=document.createElement("a");
        a.href=url;a.download=pname.toLowerCase().replace(/\s/g,"-")+"-campaign-pack.zip";
        document.body.appendChild(a);a.click();document.body.removeChild(a);window.URL.revokeObjectURL(url);
        setExportLoading(false);
      })
      .catch(function(e){console.error("Export failed:",e);setExportLoading(false);});
  }

  function sendTestEmail(){
    if(!assets||!assets.email_html)return;
    var email=agentProfile.email||"";
    if(!email){alert("Set your email in Agent Profile first.");return;}
    setTestEmailSent(false);
    fetch(API+"/email/test",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({project_name:proj?proj.name||name:name,subject:(camp?camp.headlines.email_subject:"Campaign Preview")+" - "+name,
        html_content:assets.email_html,to_email:email})})
      .then(function(r){return r.json();})
      .then(function(d){if(d.status==="sent")setTestEmailSent(true);else alert("Failed: "+(d.message||"Unknown error"));})
      .catch(function(e){alert("Error: "+e.message);});
  }

  function rateAsset(assetKey,rating,issues){
    var pname=proj?proj.name||name:name;
    setRatings(function(p){var n={...p};n[assetKey]=rating;return n;});
    fetch(API+"/feedback/rate",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({project_name:pname,asset_key:assetKey,direction:dir||"editorial",rating:rating,issues:issues||[],notes:""})})
      .catch(function(e){console.error("Rating failed:",e);});
  }

  // Helper: add an incentive to both proj.incentives and selectedIncentives
  function addIncentive(value) {
    if(!value||!value.trim())return;
    var v=value.trim();
    setProj(function(p){
      var incs=p.incentives?[...p.incentives]:[];
      if(incs.indexOf(v)===-1)incs.push(v);
      return {...p,incentives:incs};
    });
    setSelectedIncentives(function(p){return p.indexOf(v)===-1?p.concat([v]):p;});
  }

  // Helper: remove an incentive from proj.incentives and selectedIncentives
  function removeIncentive(value) {
    setProj(function(p){return {...p,incentives:(p.incentives||[]).filter(function(x){return x!==value;})};});
    setSelectedIncentives(function(p){return p.filter(function(x){return x!==value;});});
  }

  var ISSUE_TAGS=["no_image","overflow","empty_space","bad_layout","missing_price","missing_cta","wrong_dimensions","text_too_small","placeholder_visible","white_background","generic_looking","great_design"];
  var PRESET_INCENTIVES=["Free Parking","Free Locker","Capped Development Charges","Assignment Clause","Reduced Closing Costs","Free Upgrades","Early Move-In","Cash Back","Rental Guarantee","Extended Deposit","Right to Lease","Mortgage Rate Buydown"];

  useEffect(function(){return function(){if(esRef.current)esRef.current.close();};}, []);

  var card={background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.06)",borderRadius:12,padding:20};

  return <AuthGate><div style={{minHeight:"100vh",background:"#080C10",fontFamily:"'DM Sans','Helvetica Neue',sans-serif",color:"#E8E4DC"}}>
    <style>{
      "@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;1,400&display=swap');"+
      "@keyframes pulse{0%,100%{opacity:1}50%{opacity:.3}}"+
      "@keyframes slideUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}"+
      "input::placeholder{color:rgba(255,255,255,.2)}"
    }</style>

    <div style={{maxWidth:760,margin:"0 auto",padding:"36px 24px"}}>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:6}}>
        <div onClick={function(){go("input");}} style={{width:34,height:34,borderRadius:8,background:"linear-gradient(135deg,#C9A96E,#8B7345)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,fontWeight:600,color:"#080C10",cursor:"pointer"}}>A</div>
        <div onClick={function(){go("input");}} style={{cursor:"pointer"}}>
          <div style={{fontSize:17,fontWeight:500}}>AdPilot</div>
          <div style={{fontSize:10,color:"rgba(255,255,255,0.3)"}}>AI-powered pre-construction campaigns</div>
        </div>
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:12}}>
          <button onClick={function(){setShowSettings(!showSettings);}}
            style={{background:"none",border:"none",fontSize:16,cursor:"pointer",opacity:0.4,padding:4,color:"#E8DCC8"}} title="Agent settings">⚙</button>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <div style={{width:6,height:6,borderRadius:"50%",background:agentProfile.agent_name?"#4ADE80":"#FBBF24"}}/>
            <span style={{fontSize:11,color:"rgba(255,255,255,0.3)"}}>{agentProfile.agent_name?"Live":"Setup needed"}</span>
          </div>
        </div>
      </div>

      {/* Agent Settings Panel */}
      {showSettings&&<div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:12,padding:20,marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div style={{fontSize:14,fontWeight:500,color:"#E8DCC8"}}>Agent Profile — RECO Compliance</div>
          <button onClick={function(){setShowSettings(false);}} style={{background:"none",border:"none",color:"rgba(255,255,255,0.3)",cursor:"pointer",fontSize:16}}>✕</button>
        </div>
        <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:14}}>This information appears on every generated asset to comply with RECO advertising requirements.</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          {[
            {key:"agent_name",label:"Agent Name (as registered with RECO)",placeholder:"John Smith"},
            {key:"agent_title",label:"Title",placeholder:"Sales Representative"},
            {key:"brokerage_name",label:"Brokerage Name (as registered)",placeholder:"RE/MAX First Realty"},
            {key:"brokerage_descriptor",label:"Descriptor",placeholder:"Brokerage"},
            {key:"phone",label:"Phone",placeholder:"416-555-1234"},
            {key:"email",label:"Email",placeholder:"john@brokerage.com"},
          ].map(function(f){
            return <div key={f.key}>
              <div style={{fontSize:10,color:"rgba(255,255,255,0.35)",marginBottom:4,textTransform:"uppercase",letterSpacing:1}}>{f.label}</div>
              <input value={agentProfile[f.key]||""} placeholder={f.placeholder}
                onChange={function(e){var v=e.target.value;setAgentProfile(function(p){var n={...p};n[f.key]=v;return n;});}}
                style={{width:"100%",padding:"8px 10px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:8,color:"#E8DCC8",fontSize:13,outline:"none",fontFamily:"'DM Sans',sans-serif",boxSizing:"border-box"}}/>
            </div>;
          })}
        </div>
        <div style={{marginTop:14,display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
          <button onClick={function(){saveAgentProfile(agentProfile);setShowSettings(false);}}
            style={{padding:"8px 20px",borderRadius:8,background:"#C9A96E",border:"none",color:"#080C10",fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Save profile</button>
          <span style={{fontSize:11,color:"rgba(255,255,255,0.25)"}}>Saved profiles appear on all future generated assets</span>
        </div>
        <div style={{marginTop:16,padding:16,background:"rgba(255,255,255,0.02)",border:"1px solid rgba(255,255,255,0.06)",borderRadius:10}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
            <div style={{width:28,height:28,borderRadius:6,background:metaConnected?"rgba(74,222,128,0.1)":"rgba(56,189,248,0.1)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>{metaConnected?"✓":"f"}</div>
            <div>
              <div style={{fontSize:13,fontWeight:500,color:"#E8DCC8"}}>{metaConnected?"Meta Ads connected":"Connect Meta Ads"}</div>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.3)"}}>{metaConnected?"Connected as "+metaUser+" — "+metaAdAccounts+" ad account"+(metaAdAccounts!==1?"s":""):"Push campaigns directly to Facebook & Instagram"}</div>
            </div>
          </div>
          {!metaConnected&&<button onClick={function(){window.location.href=API+"/auth/meta/login?agent_id="+encodeURIComponent(agentProfile.email||"agent@adpilot.io")+"&local="+(window.location.hostname==="localhost");}}
            style={{padding:"8px 18px",borderRadius:8,background:"rgba(56,189,248,0.1)",border:"1px solid rgba(56,189,248,0.2)",color:"#38BDF8",fontSize:12,fontWeight:500,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Connect with Facebook</button>}
          {metaConnected&&<button onClick={function(){fetch(API+"/auth/meta/disconnect?agent_id="+encodeURIComponent(agentProfile.email||""),{method:"POST"}).then(function(){setMetaConnected(false);setMetaUser(null);});}}
            style={{padding:"6px 14px",borderRadius:8,background:"rgba(248,113,113,0.06)",border:"1px solid rgba(248,113,113,0.15)",color:"#F87171",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Disconnect</button>}
        </div>
      </div>}

      <Steps idx={si} onNav={function(id){go(id);}}/>

      <div style={{opacity:fade?1:0,transition:"opacity 0.25s",minHeight:400}}>

        {/* INPUT */}
        {step==="input"&&<div style={{paddingTop:70,textAlign:"center"}}>
          <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:34,fontWeight:400,marginBottom:8,color:"#fff"}}>What are we launching?</h1>
          <p style={{color:"rgba(255,255,255,0.35)",fontSize:15,marginBottom:44}}>Type a project name. Our agents handle the rest.</p>
          <div style={{maxWidth:480,margin:"0 auto"}}>
            <div style={{display:"flex",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:12,overflow:"hidden"}}>
              <input type="text" placeholder="e.g. 8 Elm Condos Toronto" value={name}
                onChange={function(e){setName(e.target.value);}}
                onKeyDown={function(e){if(e.key==="Enter"&&name.trim())startResearch(name.trim());}}
                style={{flex:1,padding:"15px 20px",background:"transparent",border:"none",color:"#fff",fontSize:16,outline:"none",fontFamily:"'DM Sans',sans-serif"}}/>
              <button onClick={function(){if(name.trim())startResearch(name.trim());}}
                style={{padding:"15px 26px",background:name.trim()?"#C9A96E":"rgba(201,169,110,0.2)",border:"none",color:name.trim()?"#080C10":"rgba(255,255,255,0.2)",fontSize:14,fontWeight:600,cursor:name.trim()?"pointer":"default",fontFamily:"'DM Sans',sans-serif"}}>Launch</button>
            </div>
            <div style={{marginTop:20,display:"flex",gap:8,justifyContent:"center",flexWrap:"wrap"}}>
              {["8 Elm Condos Toronto","Brightwater Mississauga","Pinnacle One Yonge"].map(function(s){
                return <button key={s} onClick={function(){setName(s);}}
                  style={{padding:"5px 12px",borderRadius:20,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",color:"rgba(255,255,255,0.4)",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>{s}</button>;
              })}
            </div>
            {recents.length>0&&<div style={{marginTop:32,textAlign:"left"}}>
              <div style={{fontSize:11,textTransform:"uppercase",letterSpacing:1.5,color:"rgba(255,255,255,0.25)",marginBottom:10,fontWeight:500,textAlign:"center"}}>Recent projects</div>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {recents.map(function(r){
                  var ago=Math.round((Date.now()-r.time)/60000);
                  var agoText=ago<1?"just now":ago<60?ago+"m ago":ago<1440?Math.round(ago/60)+"h ago":Math.round(ago/1440)+"d ago";
                  var statusColor=r.status==="running"?"#4ADE80":r.status==="paused"?"#FBBF24":"rgba(255,255,255,0.2)";
                  var statusLabel=r.status==="running"?"Running":r.status==="paused"?"Paused":r.deployed?"Deployed":"Draft";
                  return <div key={r.name} style={{...card,padding:14,cursor:"pointer",transition:"border-color 0.2s"}}
                    onClick={function(){setName(r.name);startResearch(r.name);}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
                      <div style={{width:32,height:32,borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",
                        background:r.score>=80?"rgba(74,222,128,0.1)":r.score>=50?"rgba(251,191,36,0.1)":"rgba(255,255,255,0.05)",
                        color:r.score>=80?"#4ADE80":r.score>=50?"#FBBF24":"rgba(255,255,255,0.3)",fontSize:12,fontWeight:600,flexShrink:0}}>{r.score}%</div>
                      <div style={{flex:1}}><div style={{fontSize:14,fontWeight:500,color:"#E8DCC8"}}>{r.name}</div></div>
                      <div style={{display:"flex",alignItems:"center",gap:4}}>
                        <div style={{width:6,height:6,borderRadius:"50%",background:statusColor}}/>
                        <span style={{fontSize:10,color:statusColor,fontWeight:500}}>{statusLabel}</span>
                      </div>
                    </div>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap",paddingLeft:42}}>
                      {r.direction&&<span style={{padding:"2px 8px",borderRadius:10,fontSize:10,background:r.direction==="editorial"?"rgba(201,169,110,0.08)":"rgba(56,189,248,0.08)",color:r.direction==="editorial"?"#C9A96E":"#38BDF8"}}>{r.direction}</span>}
                      {r.theme&&<span style={{padding:"2px 8px",borderRadius:10,fontSize:10,background:"rgba(255,255,255,0.04)",color:"rgba(255,255,255,0.35)"}}>{r.theme}</span>}
                      {r.leadCount>0&&<span style={{padding:"2px 8px",borderRadius:10,fontSize:10,background:"rgba(74,222,128,0.08)",color:"#4ADE80"}}>{r.leadCount} lead{r.leadCount!==1?"s":""}{r.hotLeads?" ("+r.hotLeads+" hot)":""}</span>}
                      {r.channels&&<span style={{padding:"2px 8px",borderRadius:10,fontSize:10,background:"rgba(255,255,255,0.04)",color:"rgba(255,255,255,0.3)"}}>{r.channels} channels</span>}
                      <span style={{padding:"2px 8px",borderRadius:10,fontSize:10,background:"rgba(255,255,255,0.03)",color:"rgba(255,255,255,0.2)"}}>{agoText}</span>
                    </div>
                  </div>;
                })}
              </div>
            </div>}
          </div>
        </div>}

        {/* RESEARCH */}
        {step==="research"&&<div>
          <Badge n={1} label="Research agent" on/>
          <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:400,marginBottom:20}}>Researching "{name}"</h2>
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            {logs.map(function(l,i){
              var c=l.s==="done"?"#4ADE80":l.s==="active"?"#FBBF24":l.s==="warning"?"#FB923C":"rgba(255,255,255,0.2)";
              return <div key={i} style={{...card,padding:11,display:"flex",alignItems:"center",gap:10,animation:"slideUp 0.3s ease"}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:c,flexShrink:0,animation:l.s==="active"?"pulse 1.5s ease infinite":"none"}}/>
                <span style={{fontSize:13,color:"#E8DCC8"}}>{l.text}</span>
              </div>;
            })}
          </div>
          {rErr&&<Card style={{marginTop:14,borderColor:"rgba(248,113,113,0.2)"}}><p style={{fontSize:13,color:"#F87171",margin:0}}>{rErr}</p><Btn onClick={resetAll}>Try again</Btn></Card>}
          {rDone&&<div style={{marginTop:18}}><Btn primary onClick={function(){go("decision");}}>Review findings</Btn></div>}
        </div>}

        {/* DECISION */}
        {step==="decision"&&rr&&<div>
          <Badge n={1} label="Review" on/>
          <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:400,marginBottom:14}}>Data assessment</h2>
          <Card style={{marginBottom:14}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <span style={{fontSize:14,fontWeight:500}}>Completeness</span>
              <span style={{fontSize:22,fontWeight:600,color:rr.completeness_score>=70?"#4ADE80":"#FBBF24"}}>{rr.completeness_score}%</span>
            </div>
            <Bar p={rr.completeness_score} c={rr.completeness_score>=70?"#4ADE80":"#FBBF24"}/>
            {proj.data_confidence&&<div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:10}}>
              <span style={{fontSize:13,color:"rgba(255,255,255,0.5)"}}>Data confidence</span>
              <span style={{fontSize:13,fontWeight:600,padding:"2px 10px",borderRadius:8,background:proj.data_confidence==="high"?"#166534":proj.data_confidence==="medium"?"#854D0E":"#991B1B",color:proj.data_confidence==="high"?"#4ADE80":proj.data_confidence==="medium"?"#FBBF24":"#FCA5A5"}}>{proj.data_confidence}</span>
            </div>}
            {proj.data_conflicts&&proj.data_conflicts.length>0&&<div style={{marginTop:10}}>
              {proj.data_conflicts.map(function(c,i){return <div key={i} style={{fontSize:12,color:"#FBBF24",marginTop:4,lineHeight:1.4}}>{"⚠ "+c.field+": "+(c.values||[]).join(" vs ")+" — verify before publishing"}</div>;})}
            </div>}
          </Card>
          {rr.missing_fields.length>0&&!editing&&<Card style={{marginBottom:14}}>
            <Lbl>Missing fields</Lbl>
            <div style={{display:"flex",flexWrap:"wrap",gap:5,marginTop:6}}>
              {rr.missing_fields.map(function(f){return <span key={f} style={{padding:"3px 9px",borderRadius:12,fontSize:10,background:"rgba(251,191,36,0.08)",color:"#FBBF24",fontWeight:500}}>{f.replace(/_/g," ")}</span>;})}
            </div>
          </Card>}

          {/* Editable data card */}
          <Card style={{marginBottom:14}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <Lbl>Project data</Lbl>
              <button onClick={function(){
                if(editingData){
                  var updated={...proj};
                  Object.keys(edits).forEach(function(k){if(edits[k]!==undefined&&edits[k]!=="")updated[k]=edits[k];});
                  setProj(updated);setEditingData(false);
                  var fields=["name","developer","address","city","project_type","storeys","total_units","price_range_min","price_range_max","estimated_occupancy","walk_score","transit_score","price_per_sqft_avg"];
                  var filled=fields.filter(function(f){return updated[f]!==null&&updated[f]!==undefined&&updated[f]!=="";}).length;
                  var newScore=Math.round((filled/fields.length)*100);
                  setRR({...rr,completeness_score:Math.max(rr.completeness_score,newScore),missing_fields:fields.filter(function(f){return !updated[f];})});
                }else{setEdits({...proj});setEditingData(true);}
              }} style={{background:"none",border:"none",color:editingData?"#4ADE80":"rgba(255,255,255,0.25)",fontSize:16,cursor:"pointer",padding:"2px 6px",transition:"color 0.2s"}}
                title={editingData?"Save changes":"Edit fields"}>{editingData?"✓":"✎"}</button>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              {[
                {l:"Project",k:"name",v:proj.name},{l:"Developer",k:"developer",v:proj.developer},
                {l:"Address",k:"address",v:proj.address},{l:"City",k:"city",v:proj.city},
                {l:"Type",k:"project_type",v:proj.project_type},{l:"Storeys",k:"storeys",v:proj.storeys,num:true},
                {l:"Units",k:"total_units",v:proj.total_units,num:true},{l:"Occupancy",k:"estimated_occupancy",v:proj.estimated_occupancy},
                {l:"Price min",k:"price_range_min",v:proj.price_range_min,num:true},{l:"Price max",k:"price_range_max",v:proj.price_range_max,num:true},
                {l:"$/sqft",k:"price_per_sqft_avg",v:proj.price_per_sqft_avg,num:true},{l:"Walk Score",k:"walk_score",v:proj.walk_score,num:true},
                {l:"Transit Score",k:"transit_score",v:proj.transit_score,num:true},{l:"Maintenance $/sqft",k:"maintenance_per_sqft",v:proj.maintenance_per_sqft,num:true},
                {l:"Parking price",k:"parking_price",v:proj.parking_price,num:true},{l:"Locker price",k:"locker_price",v:proj.locker_price,num:true},
              ].map(function(d){
                var isMissing=!d.v&&d.v!==0;
                if(editing||editingData){
                  return <div key={d.k}>
                    <Lbl>{d.l}</Lbl>
                    <input value={edits[d.k]!=null?edits[d.k]:""} onChange={function(e){var v=e.target.value;setEdits(function(p){var n={...p};n[d.k]=d.num?Number(v)||v:v;return n;});}}
                      placeholder={isMissing?"Enter "+d.l.toLowerCase():""}
                      style={{width:"100%",padding:"8px 10px",background:isMissing?"rgba(251,191,36,0.06)":"rgba(255,255,255,0.04)",border:"1px solid "+(isMissing?"rgba(251,191,36,0.2)":"rgba(255,255,255,0.08)"),borderRadius:8,color:"#E8DCC8",fontSize:13,outline:"none",fontFamily:"'DM Sans',sans-serif",boxSizing:"border-box"}}/>
                  </div>;
                }
                return <div key={d.k}>
                  <Lbl>{d.l}</Lbl>
                  <Val>{d.num&&d.v?d.k.includes("price")||d.k.includes("maintenance")?fmtF(d.v):d.v:d.v||<span style={{color:"rgba(251,191,36,0.5)"}}>—</span>}</Val>
                </div>;
              })}
            </div>
            {proj.is_master_plan&&<div style={{marginTop:14}}>
              <div style={{display:"inline-block",padding:"4px 12px",borderRadius:8,background:"rgba(20,184,166,0.15)",color:"#2DD4BF",fontSize:12,fontWeight:600,letterSpacing:0.5,marginBottom:10}}>MASTER PLAN COMMUNITY</div>
              {proj.total_community_units&&<div style={{fontSize:13,color:"rgba(255,255,255,0.5)",marginBottom:8}}>{proj.total_community_units} total units across {proj.community_phases||"multiple"} phases</div>}
              {proj.sub_projects&&proj.sub_projects.length>0&&<div style={{borderTop:"1px solid rgba(255,255,255,0.06)",paddingTop:10}}>
                <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
                  <thead><tr style={{color:"rgba(255,255,255,0.4)",textAlign:"left"}}>
                    <th style={{padding:"4px 6px",fontWeight:500}}>Phase / Building</th>
                    <th style={{padding:"4px 6px",fontWeight:500}}>Type</th>
                    <th style={{padding:"4px 6px",fontWeight:500}}>Storeys</th>
                    <th style={{padding:"4px 6px",fontWeight:500}}>Units</th>
                    <th style={{padding:"4px 6px",fontWeight:500}}>Price range</th>
                    <th style={{padding:"4px 6px",fontWeight:500}}>Occupancy</th>
                  </tr></thead>
                  <tbody>{proj.sub_projects.map(function(sp,i){return <tr key={i} style={{borderTop:"1px solid rgba(255,255,255,0.04)"}}>
                    <td style={{padding:"6px",color:"#E8DCC8"}}>{sp.name||sp.phase||"Phase "+(i+1)}</td>
                    <td style={{padding:"6px",color:"rgba(255,255,255,0.6)"}}>{sp.building_type||"—"}</td>
                    <td style={{padding:"6px",color:"rgba(255,255,255,0.6)"}}>{sp.storeys||"—"}</td>
                    <td style={{padding:"6px",color:"rgba(255,255,255,0.6)"}}>{sp.total_units||"—"}</td>
                    <td style={{padding:"6px",color:"rgba(255,255,255,0.6)"}}>{sp.price_range_min?fmtF(sp.price_range_min)+(sp.price_range_max?" – "+fmtF(sp.price_range_max):""):"—"}</td>
                    <td style={{padding:"6px",color:"rgba(255,255,255,0.6)"}}>{sp.estimated_occupancy||"—"}</td>
                  </tr>;})}</tbody>
                </table>
              </div>}
            </div>}
          </Card>

          {/* Unit types */}
          {proj.unit_types&&proj.unit_types.length>0&&<Card style={{marginBottom:14}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <Lbl>Unit mix</Lbl>
              <button onClick={function(){setEditingUnits(!editingUnits);}} style={{background:"none",border:"none",color:editingUnits?"#4ADE80":"rgba(255,255,255,0.25)",fontSize:16,cursor:"pointer",padding:"2px 6px"}}>{editingUnits?"✓":"✎"}</button>
            </div>
            <div style={{marginTop:8}}>
              {proj.unit_types.map(function(u,i){
                var sz=u.size_sqft_min?u.size_sqft_min+(u.size_sqft_max&&u.size_sqft_max!==u.size_sqft_min?"-"+u.size_sqft_max:"")+" sqft":"-";
                var pr=u.price_from?fmtF(u.price_from)+(u.price_to&&u.price_to!==u.price_from?" — "+fmtF(u.price_to):""):"-";
                if(editingUnits){
                  return <div key={i} style={{display:"flex",padding:"6px 0",borderBottom:"1px solid rgba(255,255,255,0.04)",fontSize:13,gap:8,alignItems:"center"}}>
                    <span style={{color:"#E8DCC8",fontWeight:500,flex:"0 0 120px"}}>{u.type}</span>
                    <input value={u.size_sqft_min||""} onChange={function(e){var v=Number(e.target.value)||null;var ut=[...proj.unit_types];ut[i]={...ut[i],size_sqft_min:v};setProj({...proj,unit_types:ut});}}
                      placeholder="Min sqft" style={{flex:"0 0 70px",padding:"4px 6px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:6,color:"#E8DCC8",fontSize:11,outline:"none",textAlign:"center",fontFamily:"'DM Sans',sans-serif"}}/>
                    <span style={{color:"rgba(255,255,255,0.2)",fontSize:10}}>-</span>
                    <input value={u.size_sqft_max||""} onChange={function(e){var v=Number(e.target.value)||null;var ut=[...proj.unit_types];ut[i]={...ut[i],size_sqft_max:v};setProj({...proj,unit_types:ut});}}
                      placeholder="Max sqft" style={{flex:"0 0 70px",padding:"4px 6px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:6,color:"#E8DCC8",fontSize:11,outline:"none",textAlign:"center",fontFamily:"'DM Sans',sans-serif"}}/>
                    <input value={u.price_from||""} onChange={function(e){var v=Number(e.target.value)||null;var ut=[...proj.unit_types];ut[i]={...ut[i],price_from:v};setProj({...proj,unit_types:ut});}}
                      placeholder="Price from" style={{flex:1,padding:"4px 6px",background:!u.price_from?"rgba(251,191,36,0.06)":"rgba(255,255,255,0.04)",border:"1px solid "+(!u.price_from?"rgba(251,191,36,0.2)":"rgba(255,255,255,0.08)"),borderRadius:6,color:"#C9A96E",fontSize:11,outline:"none",textAlign:"right",fontFamily:"'DM Sans',sans-serif"}}/>
                  </div>;
                }
                return <div key={i} style={{display:"flex",padding:"6px 0",borderBottom:"1px solid rgba(255,255,255,0.04)",fontSize:13}}>
                  <span style={{color:"#E8DCC8",fontWeight:500,flex:"0 0 140px"}}>{u.type}</span>
                  <span style={{color:"rgba(255,255,255,0.35)",flex:"0 0 140px",textAlign:"center"}}>{sz}</span>
                  <span style={{color:"#C9A96E",flex:1,textAlign:"right"}}>{pr}</span>
                </div>;
              })}
            </div>
          </Card>}

          {/* Deposit structure */}
          {proj.deposit_structure&&proj.deposit_structure.length>0&&<Card style={{marginBottom:14}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <Lbl>Deposit structure</Lbl>
              <button onClick={function(){setEditingDeposit(!editingDeposit);}} style={{background:"none",border:"none",color:editingDeposit?"#4ADE80":"rgba(255,255,255,0.25)",fontSize:16,cursor:"pointer",padding:"2px 6px"}}>{editingDeposit?"✓":"✎"}</button>
            </div>
            <div style={{marginTop:8}}>
              {proj.deposit_structure.map(function(d,i){
                if(editingDeposit){
                  return <div key={i} style={{padding:"4px 0",borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                    <input value={d.description} onChange={function(e){var ds=[...proj.deposit_structure];ds[i]={...ds[i],description:e.target.value};setProj({...proj,deposit_structure:ds});}}
                      style={{width:"100%",padding:"6px 10px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:6,color:"#E8DCC8",fontSize:13,outline:"none",fontFamily:"'DM Sans',sans-serif",boxSizing:"border-box"}}/>
                  </div>;
                }
                return <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"1px solid rgba(255,255,255,0.04)",fontSize:13}}>
                  <span style={{color:"#E8DCC8"}}>{d.description}</span>
                </div>;
              })}
            </div>
          </Card>}

          {/* Amenities */}
          {proj.amenities&&proj.amenities.length>0&&<Card style={{marginBottom:14}}>
            <Lbl>Amenities</Lbl>
            <div style={{display:"flex",flexWrap:"wrap",gap:6,marginTop:8}}>
              {proj.amenities.map(function(a,i){return <span key={i} style={{padding:"4px 10px",borderRadius:8,fontSize:11,background:"rgba(255,255,255,0.04)",color:"rgba(255,255,255,0.5)"}}>{a}</span>;})}
            </div>
          </Card>}

          {/* ── INCENTIVES ─────────────────────────────────────────── */}
          <Card style={{marginBottom:14}}>
            <Lbl>Developer incentives</Lbl>

            {/* Found by research — green=active, gray=disabled, always visible */}
            {proj.incentives&&proj.incentives.length>0&&<div style={{marginTop:8,marginBottom:12}}>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:6}}>Found by research</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {proj.incentives.map(function(inc,i){
                  var isDisabled=disabledScrapedIncentives.indexOf(inc)>=0;
                  return <span key={"s"+i} style={{
                    padding:"5px 12px",borderRadius:8,fontSize:11,
                    display:"flex",alignItems:"center",gap:6,cursor:"default",transition:"all 0.2s",
                    background:isDisabled?"rgba(255,255,255,0.04)":"rgba(74,222,128,0.08)",
                    color:isDisabled?"rgba(255,255,255,0.25)":"#4ADE80",
                    border:isDisabled?"1px solid rgba(255,255,255,0.08)":"1px solid rgba(74,222,128,0.15)",
                  }}>
                    {inc}
                    {isDisabled
                      ? <span onClick={function(){setDisabledScrapedIncentives(function(p){return p.filter(function(x){return x!==inc;});});}}
                          style={{cursor:"pointer",opacity:0.5,fontSize:11,lineHeight:1}} title="Re-enable">+</span>
                      : <span onClick={function(){setDisabledScrapedIncentives(function(p){return p.concat([inc]);});}}
                          style={{cursor:"pointer",opacity:0.5,fontSize:13,lineHeight:1}} title="Disable">×</span>
                    }
                  </span>;
                })}
              </div>
            </div>}

            {/* Preset buttons */}
            <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:6}}>{proj.incentives&&proj.incentives.length>0?"Add more incentives":"Select applicable incentives"}</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
              {PRESET_INCENTIVES.map(function(preset){
                var allIncentives=(proj.incentives||[]).concat(selectedIncentives);
                var isSelected=allIncentives.some(function(x){return x===preset||x.startsWith("Capped Development Charges:");});
                var isCapped=preset==="Capped Development Charges";

                return <button key={preset} onClick={function(){
                  if(isCapped){
                    // Toggle the capped DC input panel
                    setCappedDCInput(function(prev){return !prev;});
                    setCappedDCAmount("");
                  } else {
                    if(!isSelected){addIncentive(preset);}
                    else{removeIncentive(preset);}
                  }
                }}
                  style={{padding:"5px 12px",borderRadius:8,fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",transition:"all 0.2s",
                    background:(isSelected||(cappedDCInput&&isCapped))?"rgba(201,169,110,0.12)":"rgba(255,255,255,0.04)",
                    color:(isSelected||(cappedDCInput&&isCapped))?"#C9A96E":"rgba(255,255,255,0.5)",
                    border:(isSelected||(cappedDCInput&&isCapped))?"1px solid rgba(201,169,110,0.3)":"1px solid rgba(255,255,255,0.06)"
                  }}>{isSelected?"✓ ":""}{preset}</button>;
              })}
            </div>

            {/* Capped DC amount input — shown when Capped DC button clicked */}
            {cappedDCInput&&<div style={{marginBottom:12,padding:12,borderRadius:8,background:"rgba(201,169,110,0.06)",border:"1px solid rgba(201,169,110,0.2)"}}>
              <div style={{fontSize:11,color:"#C9A96E",marginBottom:8}}>Enter the capped amount (optional)</div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <input
                  autoFocus
                  value={cappedDCAmount}
                  onChange={function(e){setCappedDCAmount(e.target.value);}}
                  placeholder="e.g. $10,000 or leave blank"
                  onKeyDown={function(e){
                    if(e.key==="Enter"){
                      var label=cappedDCAmount.trim()?"Capped Development Charges: "+cappedDCAmount.trim():"Capped Development Charges";
                      addIncentive(label);setCappedDCInput(false);setCappedDCAmount("");
                    }
                    if(e.key==="Escape"){setCappedDCInput(false);setCappedDCAmount("");}
                  }}
                  style={{flex:1,padding:"8px 12px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(201,169,110,0.3)",borderRadius:8,color:"#E8DCC8",fontSize:13,outline:"none",fontFamily:"'DM Sans',sans-serif"}}
                />
                <button onClick={function(){
                  var label=cappedDCAmount.trim()?"Capped Development Charges: "+cappedDCAmount.trim():"Capped Development Charges";
                  addIncentive(label);setCappedDCInput(false);setCappedDCAmount("");
                }} style={{padding:"8px 16px",borderRadius:8,background:"#C9A96E",border:"none",color:"#080C10",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",whiteSpace:"nowrap"}}>Add</button>
                <button onClick={function(){setCappedDCInput(false);setCappedDCAmount("");}}
                  style={{padding:"8px 10px",borderRadius:8,background:"transparent",border:"1px solid rgba(255,255,255,0.08)",color:"rgba(255,255,255,0.3)",fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Cancel</button>
              </div>
            </div>}

            {/* Custom incentive input */}
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <input value={customIncentive} onChange={function(e){setCustomIncentive(e.target.value);}}
                placeholder="Add custom incentive..."
                onKeyDown={function(e){if(e.key==="Enter"&&customIncentive.trim()){addIncentive(customIncentive.trim());setCustomIncentive("");}}}
                style={{flex:1,padding:"7px 12px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:8,color:"#E8DCC8",fontSize:12,outline:"none",fontFamily:"'DM Sans',sans-serif"}}/>
              <button onClick={function(){if(customIncentive.trim()){addIncentive(customIncentive.trim());setCustomIncentive("");}}}
                style={{padding:"7px 14px",borderRadius:8,background:"rgba(201,169,110,0.08)",border:"1px solid rgba(201,169,110,0.2)",color:"#C9A96E",fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Add</button>
            </div>

            {/* Agent-added incentives (from presets/custom, not scraped) */}
            {selectedIncentives.length>0&&<div style={{marginTop:10}}>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:6}}>Agent-added</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {selectedIncentives.map(function(inc,i){return <span key={"a"+i} style={{padding:"5px 12px",borderRadius:8,fontSize:11,background:"rgba(201,169,110,0.08)",color:"#C9A96E",border:"1px solid rgba(201,169,110,0.15)",display:"flex",alignItems:"center",gap:6}}>
                  {inc}
                  <span onClick={function(){removeIncentive(inc);}} style={{cursor:"pointer",opacity:0.5,fontSize:13,lineHeight:1}}>×</span>
                </span>;})}
              </div>
            </div>}
          </Card>

          {/* Scraped render images */}
          {proj.render_urls&&proj.render_urls.length>0&&<Card style={{marginBottom:14}}>
            <Lbl>Project renders found ({proj.render_urls.length})</Lbl>
            <div style={{display:"flex",gap:8,marginTop:8,flexWrap:"wrap"}}>
              {proj.render_urls.map(function(u,i){
                var fname=u.split("/").pop().split("?")[0];
                return <div key={i} style={{width:100,height:70,borderRadius:8,border:"1px solid rgba(255,255,255,0.08)",overflow:"hidden",position:"relative",background:"rgba(255,255,255,0.03)",flexShrink:0}}>
                  <img src={u} alt={fname}
                    onError={function(e){e.target.style.display="none";e.target.nextSibling.style.display="flex";}}
                    style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                  <div style={{display:"none",width:"100%",height:"100%",position:"absolute",top:0,left:0,alignItems:"center",justifyContent:"center",flexDirection:"column",gap:3,padding:6,boxSizing:"border-box"}}>
                    <span style={{fontSize:16,opacity:0.4}}>🖼</span>
                    <span style={{fontSize:7,color:"rgba(255,255,255,0.3)",wordBreak:"break-all",textAlign:"center",lineHeight:1.2,maxHeight:24,overflow:"hidden"}}>{fname.length>22?fname.substring(0,22)+"...":fname}</span>
                  </div>
                </div>;
              })}
            </div>
            <div style={{fontSize:10,color:"rgba(255,255,255,0.2)",marginTop:6}}>These will be used in generated assets automatically</div>
          </Card>}

          {/* Upload zone */}
          {showUpload&&<Card style={{marginBottom:14}}>
            <Lbl>Upload renders, brochures, or price lists</Lbl>
            <div onClick={function(){if(fileRef.current)fileRef.current.click();}}
              style={{marginTop:8,padding:32,border:"2px dashed rgba(201,169,110,0.3)",borderRadius:12,textAlign:"center",cursor:"pointer",background:"rgba(201,169,110,0.03)",transition:"all 0.2s"}}>
              <div style={{fontSize:28,marginBottom:8}}>📁</div>
              <div style={{fontSize:14,color:"#C9A96E",fontWeight:500}}>{uploading?"Uploading...":"Click to select files"}</div>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginTop:4}}>JPG, PNG, WebP, PDF — Max 20MB each</div>
            </div>
            <input ref={fileRef} type="file" multiple accept=".jpg,.jpeg,.png,.webp,.gif,.pdf" onChange={handleUpload} style={{display:"none"}}/>
            {imageUrls.length>0&&<div style={{marginTop:12}}>
              <Lbl>Uploaded images ({imageUrls.length})</Lbl>
              <div style={{display:"flex",gap:8,marginTop:6,flexWrap:"wrap"}}>
                {imageUrls.map(function(url,i){
                  return <div key={i} style={{position:"relative"}}>
                    <img src={API+url} alt={"Upload "+(i+1)} style={{width:80,height:80,objectFit:"cover",borderRadius:8,border:"1px solid rgba(255,255,255,0.1)"}}/>
                    <button onClick={function(){setImageUrls(function(p){return p.filter(function(_,j){return j!==i;});});}}
                      style={{position:"absolute",top:-6,right:-6,width:18,height:18,borderRadius:"50%",background:"rgba(248,113,113,0.8)",border:"none",color:"#fff",fontSize:10,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
                  </div>;
                })}
              </div>
            </div>}
          </Card>}

          <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
            {camp?<Btn primary onClick={function(){go("strategy");}}>View campaign →</Btn>:<Btn primary onClick={startCampaign}>Generate campaign</Btn>}
            {camp&&<Btn onClick={startCampaign}>Regenerate campaign</Btn>}
            {rr.missing_fields.length>0&&!editing&&<Btn onClick={function(){setEditing(true);setEdits({...proj});}}>Fill missing fields</Btn>}
            <Btn onClick={function(){setShowUpload(!showUpload);}}>{showUpload?"Hide upload":"Upload files"}{imageUrls.length>0?" ("+imageUrls.length+")":""}</Btn>
            <Btn onClick={function(){startResearch(name,true);}}>Re-research</Btn>
          </div>
        </div>}

        {/* CAMPAIGN STRATEGY */}
        {step==="strategy"&&<div>
          <Badge n={3} label="Campaign strategy" on/>
          {campLoad&&!camp&&<div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:400,marginBottom:6}}>Generating campaign...</h2>
            <p style={{color:"rgba(255,255,255,0.35)",fontSize:14,marginBottom:16}}>Claude is crafting creative direction across 11 channels. ~60 seconds.</p>
            <Card style={{display:"flex",alignItems:"center",gap:12,padding:14}}>
              <div style={{width:10,height:10,borderRadius:"50%",background:"#FBBF24",animation:"pulse 1.5s ease infinite"}}/>
              <span style={{fontSize:13,color:"#E8DCC8"}}>Analyzing positioning, writing copy, building strategies...</span>
            </Card>
          </div>}
          {campErr&&<Card style={{borderColor:"rgba(248,113,113,0.2)"}}><p style={{fontSize:13,color:"#F87171",margin:0}}>Failed: {campErr}</p><Btn onClick={startCampaign}>Retry</Btn></Card>}
          {camp&&<div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:400,marginBottom:4}}>{camp.theme_name}</h2>
            <p style={{color:"rgba(255,255,255,0.35)",fontSize:13,marginBottom:16}}>{camp.theme_rationale}</p>
            <Card style={{marginBottom:10}}>
              <Lbl>Palette</Lbl>
              <div style={{display:"flex",gap:8,marginTop:6,marginBottom:14}}>
                {[camp.palette.primary,camp.palette.secondary,camp.palette.accent,camp.palette.background,camp.palette.text].map(function(c,i){return <Swatch key={i} hex={c} name={camp.palette.names[i]||""}/>;})}
              </div>
              <Lbl>Typography</Lbl>
              <Val>{camp.typography.headline_font} + {camp.typography.body_font}</Val>
            </Card>
            <Card style={{marginBottom:10}}>
              <Lbl>Headlines</Lbl>
              <div style={{fontFamily:"'Playfair Display',serif",fontSize:20,color:"#fff",padding:"6px 0"}}>{camp.headlines.primary}</div>
              <div style={{fontSize:14,color:"rgba(255,255,255,0.5)",marginBottom:8}}>{camp.headlines.secondary}</div>
              {[{l:"Email",v:camp.headlines.email_subject},{l:"Social",v:camp.headlines.social_hook},{l:"WhatsApp",v:camp.headlines.whatsapp_intro},{l:"LinkedIn",v:camp.headlines.linkedin_hook}].map(function(h){
                return <div key={h.l} style={{display:"flex",gap:10,padding:"3px 0",fontSize:12}}>
                  <span style={{color:"rgba(255,255,255,0.3)",minWidth:70}}>{h.l}</span>
                  <span style={{color:"#E8DCC8"}}>{h.v}</span>
                </div>;
              })}
            </Card>
            <Card style={{marginBottom:10}}>
              <Lbl>Email copy</Lbl>
              <p style={{fontSize:13,lineHeight:1.5,color:"rgba(255,255,255,0.5)",margin:"6px 0 12px"}}>{camp.body_copy_email}</p>
              <div style={{display:"flex",gap:10,margin:"8px 0"}}>
                <span style={{padding:"7px 18px",borderRadius:8,background:camp.palette.accent,color:"#fff",fontSize:12,fontWeight:600}}>{camp.cta_primary}</span>
                <span style={{padding:"7px 18px",borderRadius:8,border:"1px solid rgba(255,255,255,0.15)",color:"rgba(255,255,255,0.5)",fontSize:12}}>{camp.cta_secondary}</span>
              </div>
            </Card>
            <Card style={{marginBottom:10}}>
              <Lbl>Selling points</Lbl>
              {camp.selling_points.map(function(sp,i){return <div key={i} style={{display:"flex",gap:6,padding:"3px 0",fontSize:13,color:"#E8DCC8"}}><span style={{color:"#C9A96E"}}>{i+1}.</span>{sp}</div>;})}
              <div style={{marginTop:10,padding:"10px 14px",borderRadius:8,background:"rgba(201,169,110,0.06)",border:"1px solid rgba(201,169,110,0.12)"}}>
                <Lbl>Key differentiator</Lbl>
                <div style={{fontSize:13,color:"#E8DCC8",marginTop:4}}>{camp.key_differentiator}</div>
              </div>
            </Card>
            <Card style={{marginBottom:10}}>
              <Lbl>Audience — 3 personas</Lbl>
              {[camp.audience.investor_persona,camp.audience.end_user_persona,camp.audience.stretch_buyer_persona].map(function(p,i){
                return <div key={i} style={{padding:"10px 0",borderBottom:i<2?"1px solid rgba(255,255,255,0.04)":"none"}}>
                  <div style={{fontSize:13,fontWeight:500,color:"#C9A96E"}}>{p.name}</div>
                  <div style={{fontSize:11,color:"rgba(255,255,255,0.35)"}}>{p.age_range} | {p.income}</div>
                  <div style={{fontSize:11,color:"rgba(255,255,255,0.45)",marginTop:2}}>Motivation: {p.primary_motivation}</div>
                </div>;
              })}
            </Card>
            <div style={{marginTop:16,marginBottom:16}}>
              <Lbl>Choose design direction</Lbl>
              <p style={{fontSize:12,color:"rgba(255,255,255,0.35)",margin:"4px 0 12px"}}>This determines the visual style of all generated assets.</p>
              <div style={{display:"flex",gap:12}}>
                <div onClick={function(){startAssets("editorial");}} style={{flex:1,...card,cursor:"pointer",borderColor:dir==="editorial"?"rgba(201,169,110,0.5)":"rgba(201,169,110,0.2)",background:dir==="editorial"?"rgba(201,169,110,0.06)":"rgba(255,255,255,0.03)",transition:"all 0.2s",padding:16}}>
                  <div style={{fontSize:15,fontWeight:600,color:"#C9A96E",marginBottom:4}}>Editorial {dir==="editorial"?"✓":""}</div>
                  <div style={{fontSize:12,color:"rgba(255,255,255,0.45)"}}>Typography-dominant, dramatic, emotional. Best for lifestyle buyers and luxury positioning.</div>
                </div>
                <div onClick={function(){startAssets("analytical");}} style={{flex:1,...card,cursor:"pointer",borderColor:dir==="analytical"?"rgba(56,189,248,0.5)":"rgba(56,189,248,0.2)",background:dir==="analytical"?"rgba(56,189,248,0.06)":"rgba(255,255,255,0.03)",transition:"all 0.2s",padding:16}}>
                  <div style={{fontSize:15,fontWeight:600,color:"#38BDF8",marginBottom:4}}>Analytical {dir==="analytical"?"✓":""}</div>
                  <div style={{fontSize:12,color:"rgba(255,255,255,0.45)"}}>Data-forward, structured, professional. Best for investors and ROI-focused buyers.</div>
                </div>
              </div>
              {assets&&<div style={{marginTop:12}}><Btn primary onClick={function(){go("assets");}}>View generated assets →</Btn></div>}
            </div>
          </div>}
        </div>}

        {/* ASSETS */}
        {step==="assets"&&<div>
          <Badge n={4} label={"Assets — "+(dir||"editorial")} on/>
          {assetsLoad&&<div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:400,marginBottom:6}}>Generating 16 assets...</h2>
            <p style={{color:"rgba(255,255,255,0.35)",fontSize:14,marginBottom:14}}>Email, landing page, social posts, display ads — all in parallel. ~90 seconds.</p>
            <Bar p={assetProg} c="#C9A96E"/>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginTop:14}}>
              {["Email","Landing Page","IG Post","IG Story","Facebook Ad","FB Vertical","WhatsApp","LinkedIn","300×250","728×90","320×50","160×600","300×600","336×280","970×250","320×100"].map(function(a,i){
                var done=assetProg>(i+1)*6;
                return <div key={a} style={{...card,padding:10,opacity:done?1:0.3,transition:"opacity 0.3s"}}>
                  <div style={{fontSize:12,fontWeight:500,color:"#E8DCC8"}}>{a}</div>
                  <div style={{fontSize:10,color:done?"#4ADE80":"rgba(255,255,255,0.2)",marginTop:2}}>{done?"Ready":"Generating..."}</div>
                </div>;
              })}
            </div>
          </div>}
          {assetsErr&&<Card style={{borderColor:"rgba(248,113,113,0.2)"}}><p style={{fontSize:13,color:"#F87171",margin:0}}>Failed: {assetsErr}</p></Card>}
          {assets&&!assetsLoad&&<div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:400,marginBottom:14}}>Assets ready</h2>
            <Card style={{marginBottom:10}}>
              <Lbl>Generated assets — click to preview</Lbl>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:10}}>
                {[
                  {name:"Email",icon:"✉",key:"email_html",dim:"600px"},
                  {name:"Landing Page",icon:"🌐",key:"landing_page_html",dim:"Full width"},
                  {name:"Instagram Post",icon:"📷",key:"instagram_post",dim:"1080×1080"},
                  {name:"Instagram Story",icon:"📱",key:"instagram_story",dim:"1080×1920"},
                  {name:"Facebook Ad",icon:"📘",key:"facebook_ad",dim:"1200×628"},
                  {name:"Facebook Ad Vertical",icon:"📱",key:"facebook_ad_vertical",dim:"1080×1350"},
                  {name:"WhatsApp Flyer",icon:"💬",key:"whatsapp_flyer",dim:"800×1200"},
                  {name:"LinkedIn Post",icon:"💼",key:"linkedin_post",dim:"1200×627"},
                  {name:"Google 300×250",icon:"🖼",key:"google_300x250",dim:"300×250"},
                  {name:"Google 728×90",icon:"📐",key:"google_728x90",dim:"728×90"},
                  {name:"Google 320×50",icon:"📏",key:"google_320x50",dim:"320×50"},
                  {name:"Google 160×600",icon:"📊",key:"google_160x600",dim:"160×600"},
                  {name:"Google 300×600",icon:"📑",key:"google_300x600",dim:"300×600"},
                  {name:"Google 336×280",icon:"🔲",key:"google_336x280",dim:"336×280"},
                  {name:"Google 970×250",icon:"🖥",key:"google_970x250",dim:"970×250"},
                  {name:"Google 320×100",icon:"📲",key:"google_320x100",dim:"320×100"},
                ].map(function(a){
                  var html=assets[a.key]||"";
                  var hasContent=typeof html==="string"&&html.length>50;
                  var myRating=ratings[a.key]||0;
                  return <div key={a.name} style={{...card,padding:12,display:"flex",flexDirection:"column",gap:6}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,cursor:hasContent?"pointer":"default"}} onClick={function(){if(hasContent){var w=window.open();w.document.write(html);w.document.close();}}}>
                      <span style={{fontSize:18}}>{a.icon}</span>
                      <div style={{flex:1}}>
                        <div style={{fontSize:13,fontWeight:500,color:"#E8DCC8"}}>{a.name}</div>
                        <div style={{fontSize:10,color:hasContent?"#4ADE80":"rgba(255,255,255,0.25)",marginTop:1}}>{hasContent?"Ready":"Generating..."}</div>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <div style={{fontSize:9,color:"rgba(255,255,255,0.2)"}}>{a.dim}</div>
                        {hasContent&&<span style={{fontSize:10,padding:"2px 7px",borderRadius:6,background:"rgba(201,169,110,0.1)",color:"#C9A96E",fontWeight:500}}>Preview</span>}
                      </div>
                    </div>
                    {hasContent&&<div style={{display:"flex",alignItems:"center",gap:6,paddingLeft:28}}>
                      <button onClick={function(e){e.stopPropagation();rateAsset(a.key,1,["great_design"]);}}
                        style={{padding:"2px 8px",borderRadius:6,fontSize:12,cursor:"pointer",border:"1px solid "+(myRating===1?"rgba(74,222,128,0.4)":"rgba(255,255,255,0.08)"),background:myRating===1?"rgba(74,222,128,0.1)":"transparent",color:myRating===1?"#4ADE80":"rgba(255,255,255,0.3)",fontFamily:"'DM Sans',sans-serif"}}>👍</button>
                      <button onClick={function(e){e.stopPropagation();rateAsset(a.key,-1,[]);setRatingIssues(a.key);}}
                        style={{padding:"2px 8px",borderRadius:6,fontSize:12,cursor:"pointer",border:"1px solid "+(myRating===-1?"rgba(248,113,113,0.4)":"rgba(255,255,255,0.08)"),background:myRating===-1?"rgba(248,113,113,0.1)":"transparent",color:myRating===-1?"#F87171":"rgba(255,255,255,0.3)",fontFamily:"'DM Sans',sans-serif"}}>👎</button>
                      {ratingIssues===a.key&&<div style={{display:"flex",gap:4,flexWrap:"wrap",flex:1}}>
                        {ISSUE_TAGS.slice(0,8).map(function(tag){
                          return <button key={tag} onClick={function(e){e.stopPropagation();rateAsset(a.key,-1,[tag]);setRatingIssues(null);}}
                            style={{padding:"1px 6px",borderRadius:4,fontSize:9,cursor:"pointer",border:"1px solid rgba(255,255,255,0.08)",background:"rgba(255,255,255,0.04)",color:"rgba(255,255,255,0.4)",fontFamily:"'DM Sans',sans-serif",whiteSpace:"nowrap"}}>{tag.replace(/_/g," ")}</button>;
                        })}
                      </div>}
                    </div>}
  </div>;
                })}
              </div>
            </Card>
            <Card style={{marginBottom:10}}>
              <Lbl>Social copy</Lbl>
              {assets.social_copy&&assets.social_copy.instagram&&<div style={{marginTop:6}}>
                <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:3}}>Instagram</div>
                <div style={{fontSize:12,color:"#E8DCC8",lineHeight:1.5}}>{assets.social_copy.instagram.caption}</div>
                <div style={{fontSize:11,color:"rgba(201,169,110,0.6)",marginTop:4}}>{assets.social_copy.instagram.hashtags}</div>
              </div>}
              {assets.social_copy&&assets.social_copy.whatsapp&&<div style={{marginTop:12}}>
                <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:3}}>WhatsApp</div>
                <div style={{fontSize:12,color:"#E8DCC8",lineHeight:1.5}}>{assets.social_copy.whatsapp.message}</div>
              </div>}
              {assets.social_copy&&assets.social_copy.sms&&<div style={{marginTop:12}}>
                <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:3}}>SMS</div>
                <div style={{fontSize:12,color:"#E8DCC8"}}>{assets.social_copy.sms.message}</div>
              </div>}
            </Card>
            <div style={{display:"flex",gap:10}}>
              <Btn primary onClick={startDeploy}>Deploy campaign</Btn>
              <Btn onClick={function(){startAssets(dir==="editorial"?"analytical":"editorial");}}>Try {dir==="editorial"?"analytical":"editorial"} direction</Btn>
              <Btn onClick={function(){go("strategy");}}>Back to campaign</Btn>
            </div>
          </div>}
        </div>}

        {/* DISTRIBUTION */}
        {step==="distribution"&&<div>
          <Badge n={5} label="Distribution" on/>
          {deployLoading&&!deployment&&<div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:400,marginBottom:6}}>Deploying campaign...</h2>
            <p style={{color:"rgba(255,255,255,0.35)",fontSize:14}}>Setting up landing page, generating tracking links...</p>
            <Card style={{display:"flex",alignItems:"center",gap:12,padding:14,marginTop:14}}>
              <div style={{width:10,height:10,borderRadius:"50%",background:"#FBBF24",animation:"pulse 1.5s ease infinite"}}/>
              <span style={{fontSize:13,color:"#E8DCC8"}}>Deploying to all channels...</span>
            </Card>
          </div>}
          {deployment&&<div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:400,marginBottom:4}}>Campaign deployed</h2>
            <p style={{color:"rgba(255,255,255,0.35)",fontSize:13,marginBottom:14}}>{deployment.deployed_channels} of {deployment.total_channels} channels ready</p>
            <Card style={{marginBottom:10,borderColor:"rgba(201,169,110,0.15)"}}>
              <Lbl>Quick actions</Lbl>
              <div style={{display:"flex",gap:10,marginTop:10,flexWrap:"wrap"}}>
                <button onClick={downloadExportPack} disabled={exportLoading}
                  style={{padding:"10px 20px",borderRadius:8,background:"#C9A96E",border:"none",color:"#080C10",fontSize:13,fontWeight:600,cursor:exportLoading?"default":"pointer",fontFamily:"'DM Sans',sans-serif",opacity:exportLoading?0.5:1}}>
                  {exportLoading?"Preparing ZIP...":"Download export pack"}
                </button>
                <button onClick={sendTestEmail}
                  style={{padding:"10px 20px",borderRadius:8,background:"rgba(56,189,248,0.1)",border:"1px solid rgba(56,189,248,0.2)",color:"#38BDF8",fontSize:13,fontWeight:500,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
                  {testEmailSent?"Sent! Check inbox":"Send test email to me"}
                </button>
              </div>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.25)",marginTop:8}}>Export pack includes all creatives, copy, UTM links, and platform upload guides as a ZIP file.</div>
            </Card>
            <Card style={{marginBottom:10,borderColor:agentProfile.email?"rgba(74,222,128,0.12)":"rgba(251,191,36,0.12)"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:agentProfile.email?"#4ADE80":"#FBBF24",flexShrink:0}}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:500,color:"#E8DCC8"}}>{agentProfile.email?"Lead alerts active":"Lead alerts inactive"}</div>
                  <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginTop:2}}>{agentProfile.email?"Notifications sent to "+agentProfile.email:"Add your email in Agent Profile (gear icon) to receive instant lead alerts"}</div>
                </div>
              </div>
            </Card>
            {deployment.landing_page_url&&<Card style={{marginBottom:10,borderColor:"rgba(74,222,128,0.15)"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <Lbl>Landing page — live</Lbl>
                  <a href={deployment.landing_page_url} target="_blank" rel="noopener noreferrer" style={{fontSize:13,color:"#4ADE80",wordBreak:"break-all"}}>{deployment.landing_page_url}</a>
                </div>
                <button onClick={function(){navigator.clipboard.writeText(deployment.landing_page_url);}}
                  style={{padding:"6px 12px",borderRadius:6,background:"rgba(74,222,128,0.08)",border:"1px solid rgba(74,222,128,0.2)",color:"#4ADE80",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",whiteSpace:"nowrap",flexShrink:0}}>Copy URL</button>
              </div>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginTop:6}}>Leads captured automatically and scored 0-100</div>
            </Card>}
            <div style={{marginBottom:10}}>
              <Lbl>Channels</Lbl>
              <div style={{display:"flex",flexDirection:"column",gap:6,marginTop:8}}>
                {deployment.channels.map(function(ch){
                  var statusColor=ch.status==="deployed"?"#4ADE80":ch.status==="ready"?"#38BDF8":"rgba(255,255,255,0.3)";
                  var statusLabel=ch.status==="deployed"?"Live":ch.status==="ready"?"Ready":"Pending";
                  return <Card key={ch.channel} style={{padding:14}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{flex:1}}>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <div style={{width:6,height:6,borderRadius:"50%",background:statusColor,flexShrink:0}}/>
                          <div style={{fontSize:14,fontWeight:500,color:"#E8DCC8"}}>{ch.channel}</div>
                        </div>
                        <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginTop:3,paddingLeft:14}}>{ch.notes}</div>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:6}}>
                        {ch.utm_link&&<button onClick={function(){navigator.clipboard.writeText(ch.utm_link);}}
                          style={{padding:"4px 10px",borderRadius:6,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",color:"rgba(255,255,255,0.4)",fontSize:10,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Copy UTM</button>}
                        <span style={{fontSize:10,padding:"3px 10px",borderRadius:10,fontWeight:500,background:ch.status==="deployed"?"rgba(74,222,128,0.1)":ch.status==="ready"?"rgba(56,189,248,0.1)":"rgba(255,255,255,0.05)",color:statusColor}}>{statusLabel}</span>
                      </div>
                    </div>
                  </Card>;
                })}
              </div>
            </div>
            {metaConnected&&<Card style={{marginBottom:10,borderColor:"rgba(56,189,248,0.12)"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:"#38BDF8"}}/>
                <Lbl style={{margin:0}}>Launch on Meta (Facebook + Instagram)</Lbl>
              </div>
              {!launchResult?<div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
                  <div>
                    <div style={{fontSize:10,color:"rgba(255,255,255,0.35)",marginBottom:4,textTransform:"uppercase"}}>Daily budget</div>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <input type="range" min="10" max="200" step="5" value={launchBudget} onChange={function(e){setLaunchBudget(Number(e.target.value));}} style={{flex:1}}/>
                      <span style={{fontSize:15,fontWeight:600,color:"#38BDF8",minWidth:50,textAlign:"right"}}>${launchBudget}/d</span>
                    </div>
                  </div>
                  <div>
                    <div style={{fontSize:10,color:"rgba(255,255,255,0.35)",marginBottom:4,textTransform:"uppercase"}}>Target city</div>
                    <input value={launchCity||(proj&&proj.city)||""} onChange={function(e){setLaunchCity(e.target.value);}} placeholder={proj&&proj.city?proj.city:"e.g. Toronto"}
                      style={{width:"100%",padding:"7px 10px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:8,color:"#E8DCC8",fontSize:12,outline:"none",fontFamily:"'DM Sans',sans-serif",boxSizing:"border-box"}}/>
                  </div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                  <div>
                    <div style={{fontSize:10,color:"rgba(255,255,255,0.35)",marginBottom:4,textTransform:"uppercase"}}>Age range</div>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      <input type="number" value={launchAgeMin} onChange={function(e){setLaunchAgeMin(Number(e.target.value));}} style={{width:50,padding:"6px 8px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:6,color:"#E8DCC8",fontSize:12,outline:"none",textAlign:"center",fontFamily:"'DM Sans',sans-serif"}}/>
                      <span style={{color:"rgba(255,255,255,0.2)"}}>—</span>
                      <input type="number" value={launchAgeMax} onChange={function(e){setLaunchAgeMax(Number(e.target.value));}} style={{width:50,padding:"6px 8px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:6,color:"#E8DCC8",fontSize:12,outline:"none",textAlign:"center",fontFamily:"'DM Sans',sans-serif"}}/>
                    </div>
                  </div>
                  <div style={{display:"flex",alignItems:"flex-end"}}>
                    <button onClick={function(){
                      if(!proj||!camp||!assets)return;
                      setLaunching(true);setLaunchResult(null);
                      var pname=proj.name||name;
                      fetch(API+"/meta/campaign/create",{method:"POST",headers:{"Content-Type":"application/json"},
                        body:JSON.stringify({agent_id:agentProfile.email||"maged.rmze@gmail.com",project_name:pname,
                          daily_budget_cents:launchBudget*100,launch_active:true,city:launchCity||proj.city||"",
                          age_min:launchAgeMin,age_max:launchAgeMax,headline:camp.headlines.primary||"",
                          body_text:camp.body_copy_social||"",landing_page_url:deployment&&deployment.landing_page_url?deployment.landing_page_url:"",
                          utm_campaign:pname.toLowerCase().replace(/ /g,"-")})})
                        .then(function(r){return r.json();})
                        .then(function(d){setLaunchResult(d);setLaunching(false);})
                        .catch(function(e){setLaunchResult({status:"failed",errors:[e.message]});setLaunching(false);});
                    }} disabled={launching}
                      style={{padding:"10px 24px",borderRadius:8,background:launching?"rgba(56,189,248,0.3)":"#38BDF8",border:"none",color:"#080C10",fontSize:13,fontWeight:600,cursor:launching?"default":"pointer",fontFamily:"'DM Sans',sans-serif",width:"100%"}}>
                      {launching?"Launching...":"Launch campaign — $"+launchBudget+"/day"}
                    </button>
                  </div>
                </div>
                <div style={{fontSize:10,color:"rgba(255,255,255,0.2)"}}>Campaign launches immediately on Facebook + Instagram. Your Meta billing handles ad spend.</div>
              </div>:<div>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                  <div style={{width:8,height:8,borderRadius:"50%",background:launchResult.status==="launched"?"#4ADE80":"#F87171"}}/>
                  <span style={{fontSize:14,fontWeight:500,color:launchResult.status==="launched"?"#4ADE80":"#F87171"}}>{launchResult.status==="launched"?"Campaign is live!":"Launch failed"}</span>
                </div>
                {launchResult.campaign_id&&<div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:4}}>Campaign ID: {launchResult.campaign_id}</div>}
                {launchResult.daily_budget&&<div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:4}}>Budget: {launchResult.daily_budget}</div>}
                {launchResult.ad_ids&&launchResult.ad_ids.length>0&&<div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginBottom:4}}>{launchResult.ad_ids.length} ad{launchResult.ad_ids.length!==1?"s":""} created</div>}
                {launchResult.errors&&launchResult.errors.length>0&&<div style={{fontSize:11,color:"#F87171",marginTop:4}}>{launchResult.errors.join(", ")}</div>}
                {launchResult.status==="launched"&&<div style={{display:"flex",gap:8,marginTop:10}}>
                  <button onClick={function(){fetch(API+"/meta/campaign/pause",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({agent_id:agentProfile.email||"maged.rmze@gmail.com",campaign_id:launchResult.campaign_id})}).then(function(r){return r.json();}).then(function(){setLaunchResult({...launchResult,status:"paused"});});}}
                    style={{padding:"6px 14px",borderRadius:6,background:"rgba(251,191,36,0.08)",border:"1px solid rgba(251,191,36,0.15)",color:"#FBBF24",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Pause</button>
                  <button onClick={function(){setLaunchResult(null);}}
                    style={{padding:"6px 14px",borderRadius:6,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",color:"rgba(255,255,255,0.4)",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Launch new</button>
                </div>}
                {launchResult.status==="paused"&&<div style={{display:"flex",gap:8,marginTop:10}}>
                  <button onClick={function(){fetch(API+"/meta/campaign/resume",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({agent_id:agentProfile.email||"maged.rmze@gmail.com",campaign_id:launchResult.campaign_id})}).then(function(r){return r.json();}).then(function(){setLaunchResult({...launchResult,status:"launched"});});}}
                    style={{padding:"6px 14px",borderRadius:6,background:"rgba(74,222,128,0.08)",border:"1px solid rgba(74,222,128,0.15)",color:"#4ADE80",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Resume</button>
                  <button onClick={function(){fetch(API+"/meta/campaign/stop",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({agent_id:agentProfile.email||"maged.rmze@gmail.com",campaign_id:launchResult.campaign_id})}).then(function(r){return r.json();}).then(function(){setLaunchResult({...launchResult,status:"stopped"});});}}
                    style={{padding:"6px 14px",borderRadius:6,background:"rgba(248,113,113,0.06)",border:"1px solid rgba(248,113,113,0.15)",color:"#F87171",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Stop</button>
                </div>}
              </div>}
            </Card>}
            {!metaConnected&&<Card style={{marginBottom:10,borderColor:"rgba(56,189,248,0.08)"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:"rgba(255,255,255,0.2)"}}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:500,color:"rgba(255,255,255,0.5)"}}>Meta Ads not connected</div>
                  <div style={{fontSize:11,color:"rgba(255,255,255,0.25)"}}>Connect in Agent Profile (gear icon) to launch campaigns on Facebook + Instagram</div>
                </div>
              </div>
            </Card>}
            <div style={{marginTop:16,display:"flex",gap:10}}>
              <Btn primary onClick={function(){fetchLeads();go("delivery");}}>View leads</Btn>
              <Btn onClick={function(){go("assets");}}>Back to assets</Btn>
            </div>
          </div>}
        </div>}

        {/* LEADS */}
        {step==="delivery"&&<div>
          <Badge n={6} label="Lead capture" on/>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:400,margin:0}}>Captured leads</h2>
            <button onClick={fetchLeads} style={{padding:"5px 12px",borderRadius:8,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",color:"rgba(255,255,255,0.4)",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Refresh</button>
          </div>
          {leadStats&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:8,marginBottom:14}}>
            <Card style={{padding:12,textAlign:"center"}}><div style={{fontSize:22,fontWeight:600,color:"#fff"}}>{leadStats.total_leads}</div><div style={{fontSize:10,color:"rgba(255,255,255,0.35)",textTransform:"uppercase",letterSpacing:1}}>Total</div></Card>
            <Card style={{padding:12,textAlign:"center"}}><div style={{fontSize:22,fontWeight:600,color:"#F87171"}}>{leadStats.hot}</div><div style={{fontSize:10,color:"rgba(255,255,255,0.35)",textTransform:"uppercase",letterSpacing:1}}>Hot</div></Card>
            <Card style={{padding:12,textAlign:"center"}}><div style={{fontSize:22,fontWeight:600,color:"#FBBF24"}}>{leadStats.warm}</div><div style={{fontSize:10,color:"rgba(255,255,255,0.35)",textTransform:"uppercase",letterSpacing:1}}>Warm</div></Card>
            <Card style={{padding:12,textAlign:"center"}}><div style={{fontSize:22,fontWeight:600,color:"#4ADE80"}}>{Math.round(leadStats.avg_score)}</div><div style={{fontSize:10,color:"rgba(255,255,255,0.35)",textTransform:"uppercase",letterSpacing:1}}>Avg score</div></Card>
          </div>}
          {leads.length===0&&<Card style={{padding:24,textAlign:"center"}}>
            <div style={{fontSize:28,marginBottom:8}}>📭</div>
            <div style={{fontSize:14,color:"rgba(255,255,255,0.5)"}}>No leads captured yet</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.3)",marginTop:4}}>Share the landing page link and leads will appear here in real-time</div>
            {deployment&&deployment.landing_page_url&&<div style={{marginTop:12}}>
              <button onClick={function(){navigator.clipboard.writeText(deployment.landing_page_url);}}
                style={{padding:"8px 16px",borderRadius:8,background:"rgba(201,169,110,0.1)",border:"1px solid rgba(201,169,110,0.2)",color:"#C9A96E",fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Copy landing page URL</button>
            </div>}
          </Card>}
          {leads.length>0&&<div style={{display:"flex",flexDirection:"column",gap:6}}>
            {leads.map(function(l,i){
              return <Card key={l.id||i} style={{padding:14}}>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:15,fontWeight:500,color:"#fff"}}>{l.name}</div>
                    <div style={{fontSize:12,color:"rgba(255,255,255,0.35)"}}>{l.email}{l.phone?" | "+l.phone:""}</div>
                    <div style={{fontSize:11,color:"rgba(255,255,255,0.25)",marginTop:2}}>{l.interest} | {l.source} | {l.created_at?new Date(l.created_at).toLocaleString():""}</div>
                    {l.engagement&&l.engagement.length>0&&<div style={{fontSize:10,color:"rgba(255,255,255,0.2)",marginTop:4}}>{l.engagement.join(" • ")}</div>}
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontSize:10,padding:"3px 9px",borderRadius:10,fontWeight:500,textTransform:"uppercase",
                      background:l.status==="hot"?"rgba(239,68,68,0.12)":l.status==="warm"?"rgba(251,191,36,0.12)":"rgba(255,255,255,0.05)",
                      color:l.status==="hot"?"#F87171":l.status==="warm"?"#FBBF24":"rgba(255,255,255,0.4)"}}>{l.status}</span>
                    <div style={{width:34,height:34,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",
                      background:"conic-gradient(#C9A96E "+l.score+"%,rgba(255,255,255,0.05) 0)",fontSize:11,fontWeight:600,color:"#fff"}}>{l.score}</div>
                  </div>
                </div>
              </Card>;
            })}
          </div>}
          <div style={{marginTop:20,display:"flex",gap:10}}>
            <Btn primary onClick={resetAll}>Launch another project</Btn>
            <Btn onClick={function(){go("distribution");}}>Back to distribution</Btn>
            <Btn onClick={function(){go("assets");}}>View assets</Btn>
          </div>
        </div>}

      </div>
    </div>
  </div>
  ;
  </AuthGate>
}
